const defaultState = {
  popup: {
    props: {},
    component: null,
    controller: null,
    showContent: false
  },
}

const state = () => ({
  popup: {
    props: defaultState.popup.props,
    component: defaultState.popup.component,
    controller: defaultState.popup.controller,
    showContent: defaultState.popup.showContent
  }
})

const getters = {
  getPopupInfo: state => state.popup
}

const mutations = {
  OPEN_POPUP(state, { component, props, controller }) {
    state.popup = { component, props, controller };
  },
  CLOSE_POPUP(state) {
    state.popup = defaultState.popup;
  },
  TOGGLE_CONTENT(state) {
    state.popup.showContent = !state.popup.showContent;
  }
}

const actions = {
  async openPopup({commit, state}, { component, props }) {
    let resolve;
    let reject;

    const popupPromise = new Promise((ok, fail) => {
      resolve = ok;
      reject = fail;
    })
    const controller = { resolve, reject };

    commit('OPEN_POPUP', { component, props, controller })

    return await popupPromise;
  },
  closePopup({commit, state}) {
    state.popup.controller.resolve(true)
    commit('CLOSE_POPUP');
  },
  toggleContent({commit}) {
    commit('TOGGLE_CONTENT')
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
